import { AbstractSchema, InferTypeFromSchema } from '../../../common/args';

export interface CapabilityDefinition<
  Name extends string,
  Schema extends AbstractSchema = {},
> {
  name: Name;
  args: Schema;
}

export class Capability<
  Name extends string = string,
  Schema extends AbstractSchema = {},
> {
  constructor(
    private readonly definition: CapabilityDefinition<Name, Schema>
  ) {}

  toString(): Name {
    return this.definition.name;
  }

  getName(): Name {
    return this.definition.name;
  }

  getArgsSchema(): Schema {
    return this.definition.args;
  }
}

export type InferCapabilityArgsType<C extends Capability<any>> =
  C extends Capability<any, infer Schema> ? InferTypeFromSchema<Schema> : never;
